export const aboutInfo = {
  brandName: "猫咪社区",
  slogan: "爱猫人的温暖聚集地",
  foundedYear: "2020",
  memberCount: "32万+",
  articleCount: "12,450",
  adoptionCount: "3,200+",
  email: "hello@catcommunity.cn",
  wechat: "CatCommunity_Official",
  weibo: "@猫咪社区官方",
  address: "北京市朝阳区猫猫大厦12层",
  phone: "400-888-9999",
};